import React from 'react';
import CaseForm from './CaseForm';
import SectionHeader from './SectionHeader'
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import DocumentForm from './DocumentForm';
import { useState, useEffect} from 'react';
import {  useParams } from 'react-router-dom';
import { HOST } from '../components/config';
const AddDocument = (props) => {
  const isContextDoc = props.isContextDoc
  const { caseId } = useParams();
  const [documentTypes, setDocumentTypes] = useState([]);
  
  const handleOnSubmit = (docInfo) => {
      try {
        docInfo['case_id'] = caseId
        fetch(HOST + '/api/assembly_case_documents/',
        {   
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
            },  
          "body": JSON.stringify(docInfo)
         })
        .then((res) => res.json())
        .then((json) => {
          if (json['id'])
            document.location.href = '/cases/' + caseId 
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };

  const loadDocumentTypes = () => {
      try {
        fetch(HOST + '/api/assembly_documents',
        {   
          "method": "GET",
          "headers" : { 
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
            },  
         })
        .then((res) => res.json())
        .then((json) => {
          setDocumentTypes(json.filter((type) => type.is_context_document == isContextDoc ))
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  }
  useEffect( () => {
    loadDocumentTypes()
  }, []);

  const handleBack = () => {
    document.location.href = '/cases/' + caseId
  }

  const title = isContextDoc ? "Start New Fact Set" : "Start New Case Document" 
  return (
    <React.Fragment>
    <Container disableGutters={false} > 
      <SectionHeader title={title} mt={4}  />
      <Divider  />
      <DocumentForm documentTypes={documentTypes} handleOnSubmit={handleOnSubmit}  handleBack={handleBack} />
    </Container>
    </React.Fragment>
  );
};

export default AddDocument;
